export const ids = [
	'fpcGlobal',
	'fpcJob',
	'jobDashboard',
	'jobRelated',
	'organizationAdmin',
	'principalAdmin',
	'projectDashboard',
	'resourceAdmin',
	'trxDashboard',
	'trxRelated',
	'userAdmin',
	'userEstimators',
	'wohBoMTrx',
	'wohParameter',
	'wohUsage',
	'wohFormula',
	'wohMaterialTemplate',
	'wohMaterial',
	'wohRecipe',
	'wohRecipeCopy',
] as const;
